export function loadScript (callback: ((this: GlobalEventHandlers, ev: Event) => unknown), scriptSrc: string) {
  const head = document.head || document.getElementsByTagName('head')[0]
  const script = document.createElement('script')

  script.async = true
  script.charset = 'utf-8'
  script.src = scriptSrc

  head.appendChild(script)

  script.onload = callback
}
